export const BOOKING_URL = "https://calendly.com/leprincemaxim/30min";

const isCalendlyEvent = (e) =>
  e.origin === "https://calendly.com" &&
  e.data &&
  typeof e.data.event === "string" &&
  e.data.event.indexOf("calendly.") === 0;

let listenerInstalled = false;
const firedBookings = new Set();

// Installs a single global postMessage listener that pushes a GTM dataLayer
// event ONLY when Calendly confirms a booking was scheduled. Safe to call
// multiple times — it self-guards so the listener is attached exactly once.
export function initCalendlyTracking() {
  if (listenerInstalled || typeof window === "undefined") return;
  listenerInstalled = true;

  window.addEventListener("message", (e) => {
    if (!isCalendlyEvent(e)) return;
    if (e.data.event !== "calendly.event_scheduled") return;

    // Dedupe per confirmed booking. Calendly includes the invitee URI in the
    // payload for a scheduled event; use it so the same booking never pushes twice.
    const inviteeUri =
      (e.data.payload && e.data.payload.invitee && e.data.payload.invitee.uri) || null;
    const key = inviteeUri || "calendly_booking";
    if (firedBookings.has(key)) return;
    firedBookings.add(key);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "calendly_booking_success",
      booking_type: "strategy_call",
    });
  });
}

// Opens Calendly as an on-page popup (official widget). Prevents default so the
// anchor never navigates. Falls back to a new tab if the widget script hasn't loaded.
export function openCalendly(e) {
  if (e) e.preventDefault();
  if (window.Calendly && typeof window.Calendly.initPopupWidget === "function") {
    window.Calendly.initPopupWidget({ url: BOOKING_URL });
  } else {
    window.open(BOOKING_URL, "_blank", "noopener,noreferrer");
  }
  return false;
}
